import { createStore } from 'vuex';

export default createStore({
  state: {
    token: '',
    isAuth: false,
    person: [],
    roles: [],
    currentRole: '',
    requestTypes: [],
    projectTypes: [],
    expertiseTypes: [],
    appSettings: {
      enableCompetencies: false,
      enableQualities: false,
      enableScientificScopes: false,
    },
  },
  getters: {
    requestTypeTextByType: (state) => (type) => {
      if (state.requestTypes) {
        const foundItem = state.requestTypes.find((item) => item.type === type);
        return foundItem ? foundItem.description : null;
      } else {
        return null;
      }
    },
    requestTypeTextById: (state) => (typeId) => {
      if (state.requestTypes) {
        const foundItem = state.requestTypes.find((item) => item.id === typeId);
        return foundItem ? foundItem.description : null;
      } else {
        return null;
      }
    },
    projectTypeOptions: (state) => (type) => {
      return state.projectTypes.map((item) => ({
        value: item.id,
        label: item.description,
        type: type,
      }));
    },
    projectTypeTextByType: (state) => (type) => {
      if (state.projectTypes) {
        const foundItem = state.projectTypes.find((item) => item.name === type);
        return foundItem ? foundItem.description : null;
      } else {
        return null;
      }
    },
    projectTypeTextById: (state) => (typeId) => {
      if (state.projectTypes) {
        const foundItem = state.projectTypes.find((item) => item.id === typeId);
        return foundItem ? foundItem.description : null;
      } else {
        return null;
      }
    },
    enableCompetencies: (state) => state.appSettings.enableCompetencies,
    enableQualities: (state) => state.appSettings.enableQualities,
    enableScientificScopes: (state) => state.appSettings.enableScientificScopes,
  },
  mutations: {
    setIsAuth(state, isAuth) {
      state.isAuth = isAuth;
    },
    setPerson(state, person) {
      state.person = person;
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setCurrentRole(state, role) {
      state.currentRole = role;
    },
    setRequestTypes(state, requestTypes) {
      state.requestTypes = requestTypes;
    },
    setProjectTypes(state, requestTypes) {
      state.projectTypes = requestTypes;
    },
    setAppSettings(state, appSettings) {
      state.appSettings = { ...state.appSettings, ...appSettings };
    },
  },
  actions: {
    async fetchRequestTypes({ commit }, api) {
      const response = await api.requestType.index();
      commit('setRequestTypes', response);
    },
    async fetchProjectTypes({ commit }, api) {
      const response = await api.projectType.index();
      commit('setProjectTypes', response);
    },
    async fetchAppSettings({ commit }, api) {
      try {
        const response = await api.setting.index();

        const parsedSettings = {};
        response.settings.forEach((setting) => {
          switch (setting.name) {
            case 'enableCompetencies':
              parsedSettings.enableCompetencies = setting.value === 'true';
              break;
            case 'enableQualities':
              parsedSettings.enableQualities = setting.value === 'true';
              break;
            case 'enableScientificScopes':
              parsedSettings.enableScientificScopes = setting.value === 'true';
          }
        });

        commit('setAppSettings', parsedSettings);
      } catch (error) {
        console.error('Error fetching app settings:', error);
      }
    },
  },
  modules: {},
});
